<template>
  <div class="about-us">
    <Scrollama @step-enter="stepEnterHandler">
      <div class=" step1" data-step="a">
        <div class="head bg-img-maintain">
          <img :src="textData.img">
          <div class="title animation">{{textData.title}}</div>
          <div class="content animation">{{textData.content}}</div>
          <!--          <div class="btn animation">查看更多</div>-->
        </div>
      </div>
      <div class=" step2" data-step="b">
        <div class="partners">
          <div class="first-level-title animation" v-show="show1">
            {{textData.t1}}
          </div>
          <div class="content animation text" v-show="show1">
            {{content2}}
          </div>
          <div class="icon animation" v-show="show1">
            <div></div>
          </div>
        </div>
      </div>
      <div class=" step3" data-step="c">
        <div class="achieve bg-img-maintain">
          <div class="first-level-title animation" v-show="show2">
            {{textData.t2}}
          </div>
          <div class="content animation" v-show="show2">
            <div class="item" v-for="(item,index) in achieveList" :key="index">
              <div class="img-item bg-img-maintain">
                <img :src="item.img" alt="">
              </div>
              <div class="txt-item">
                <div class="secondary-title">{{ item.title }}</div>
                <div class="text" v-html="item.content">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class=" step4" data-step="d">
        <div class="development bg-img-maintain">
          <div class="first-level-title animation" v-show="show3">
            {{textData.t3}}
          </div>
          <div class="tag animation animation" v-show="show3">
            <div :key="index" :class="{'item':true,'secondary-title':true,'active':currentSlide==item.num}"
                 v-for="(item,index) in developmentTitleList" @click="switchFn(item.num)">
              {{ item.title }}
            </div>
          </div>
          <div class="imgnode animation" v-show="show3">
            <el-carousel v-model="currentSlide" ref="myCarousel" :drag="true" :show-arrow="false"
                         @change="onCarouselChange" :autoplay="false" indicator-position="none" :loop="false">
              <el-carousel-item v-for="(item, index) in developmentTitleList" :key="index">
                <img style="width: 100%;height: 100%;" :src="item.img" ref="swif" @mousedown="switchImg($event)">
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
      <div class=" step5" data-step="e">
        <div class="welfare bg-img-maintain">
          <div class="first-level-title animation" v-show="show4">
            {{textData.t4}}
          </div>
          <div class="content animation" v-show="show4">
            <div class="item" :class="'item'+(index+1)" v-for="(item,index) in welfareList" :key="index">
              <div class="item-img">
                <img :src="item.img" alt="">
              </div>
              <div class="secondary-title">{{ item.title }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class=" step6" data-step="e">
        <div class="postinfo bg-img-maintain">
          <div class="first-level-title animation" v-show="show5">
            {{textData.t5}}
          </div>
          <div class="content animation" v-show="show5">
            <div class="item" v-for="(item,index) in postList" :key="index" @click="goInfo(index)">
              <div class="top">
                <div class="secondary-title">{{ item.position }}</div>
                <div class="secondary-title salary">{{ item.salary }}</div>
              </div>
              <div class="center">
                <div class="cs">{{ item.t1 }}</div>
                <div class="jy">{{ item.t4 }}</div>
                <div class="xl">{{ item.t2 }}</div>
                <div class="qy">{{ item.t3 }}</div>
              </div>
              <div class="bottom">
                <div>{{ item.pd1 }}</div>
                <div>|</div>
                <div>{{ item.pd2 }}</div>
                <div>|</div>
                <div>{{ item.pd3 }}</div>
                <div>|</div>
                <div>{{ item.pd4 }}</div>
              </div>
            </div>
          </div>
          <div class="link-style animation" v-show="show5">
            <p>点击下方链接，探索更多内容</p>
            <el-link :underline="false" type="primary" target="_blank" href="http://company.zhaopin.com/CZ285722330.htm">
              http://company.zhaopin.com/CZ285722330.htm
            </el-link>
          </div>
        </div>
      </div>
    </Scrollama>
    <footer-item></footer-item>
  </div>
</template>
<script>
import Scrollama from 'vue-scrollama'
import footerItem from '../home/components/footer-item'

export default {
  components: {
    Scrollama,
    footerItem
  },
  data () {
    return {
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      show5: false,
      currentSlide: 0,
      textData: {},
      // 在蓝智你可以实现
      achieveList: [],
      // 在蓝智我们共同成长-标题
      developmentTitleList: [],
      // 在蓝智我们共同成长-轮播图
      developmentImgList: [],
      // 蓝智福利
      welfareList: [],
      // 蓝智岗位
      postList: [],
      content2: ''
    }
  },
  methods: {
    goInfo (val) {
      this.$router.push({ path: '/recruitment-details', query: { type: val } })
    },
    switchImg (e) {
      console.log(e.screenX)
      let nodeimg = document.querySelector('img')
      console.log(nodeimg)
      nodeimg.addEventListener('drag', (params) => {
        console.log(params.screenX)
      })
    },
    onCarouselChange (index) {
      console.log(index)
      this.currentSlide = index
    },
    switchFn (val) {
      this.currentSlide = val
      this.$refs.myCarousel.setActiveItem(val)
      console.log(this.currentSlide)
    },

    stepEnterHandler ({element, index, direction}) {
      switch (element.className) {
        case 'step2':
          this.show1 = true
          break
        case 'step3':
          this.show2 = true
          break
        case 'step4':
          this.show3 = true
          break
        case 'step5':
          this.show4 = true
          break
        case 'step6':
          this.show5 = true
          break
      }
    }
  },
  mounted: function () {
    if (this.$boss) {
      this.textData = this.$boss.page611.g611[0]
      this.content2 = this.$boss.page612.g612[0].content
      this.achieveList = [...this.$boss.page613.g613].reverse()
      this.developmentTitleList = this.$boss.page614.g614.map((item, index) => {
        item.num = index
        return item
      })
      this.welfareList = [...this.$boss.page615.g615].reverse()
      let list = [...this.$boss.page616.g616]
      this.postList = list.reverse()
      // console.log(this.postList)
    }
  }
}
</script>
<style scoped lang="less">
  .link-style {
    font-size: 20px;
    padding: 50px;
    .el-link {
      color: #5084F7;
      font-size: 20px;
    }
  }
  .about-us {
    width: 100%;
    height: auto;
    font-weight: '微软雅黑';

    div {
      //一级标题
      .first-level-title {
        font-size: 42px;
        font-weight: bold;
        color: #323232;
      }

      //二级标题
      .secondary-title {
        font-size: 24px;
        font-weight: bold;
        color: #323232;
      }

      //正文
      .text {
        font-size: 20px;
        color: #323232;
        margin-top: 70px;
      }

      //背景图宽度保持不变类
      .bg-img-maintain {
        background-size: cover !important;
        background-position: center !important;
      }

      .head {
        height: 71vh;
        display: flex;
        flex-direction: column;
        align-items: baseline;
        /*padding-left: 100px;*/
        /*background: url("../../static/images/enterpriseRecruitment/banner.png") no-repeat;*/

        img {
          width: 100%;
          height: 100%;
        }

        .title {
          font-size: 52px;
          opacity: 0;
          margin-top: -45vh;
          font-weight: bold;
          color: #fff;
          padding-left: 100px;
        }

        .content {
          font-size: 32px;
          padding-left: 100px;
          opacity: 0;
          margin-top: 40px;
          color: #E6E9F3;
        }

        .btn {
          font-size: 22px;
          margin-top: 110px;
          width: 215px;
          height: 60px;
          text-align: center;
          line-height: 60px;
          color: transparent;
          border: 1px solid transparent;
          margin-bottom: 110px;
        }

      }

      .partners {
        border: 1px solid rgba(0, 0, 0, 0);
        width: 100%;
        height: 524px;
        padding: 100px 100px 0 100px;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-sizing: border-box;

        .content {
          width: 968px;
        }

        .icon {
          display: flex;
          justify-content: center;
          margin-top: 70px;

          div {
            width: 60px;
            height: 80px;
            background: url("../../static/images/aboutUs/partners/downarrow.png") no-repeat;
          }
        }
      }

      .achieve {
        border: 1px solid rgba(0, 0, 0, 0);
        padding: 50px 100px;
        height: 900px;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-sizing: border-box;
        background: url("../../static/images/enterpriseRecruitment/sx.png") no-repeat;

        .content {
          display: flex;
          justify-content: space-between;
          margin-top: 70px;

          .item {
            width: 32%;

            .img-item {
              width: 100%;
              height: 294px;

              img {
                height: 100%;
                width: 100%;
              }
            }

            // .img-item1 {
            //   background: url("../../static/images/enterpriseRecruitment/2-1.png") no-repeat;
            // }

            // .img-item2 {
            //   background: url("../../static/images/enterpriseRecruitment/2-2.png") no-repeat;
            // }

            // .img-item3 {
            //   background: url("../../static/images/enterpriseRecruitment/2-3.png") no-repeat;
            // }

            .txt-item {
              height: 260px;
              padding: 30px;
              text-align: left;
              background-color: #fff;

              .text {
                margin-top: 30px;
              }
            }
          }
        }

        .icon {
          display: flex;
          justify-content: center;
          margin-top: 70px;

          div {
            width: 60px;
            height: 80px;
            background: url("../../static/images/aboutUs/partners/downarrow.png") no-repeat;
          }
        }
      }

      .development {
        border: 1px solid rgba(0, 0, 0, 0);
        padding: 50px 100px;
        height: 1000px;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-sizing: border-box;

        .tag {
          display: flex;
          justify-content: space-between;
          margin-top: 70px;
          width: 100%;

          .item {
            // width: 407px;
            width:20vw;
            height: 128px;
            line-height: 128px;

            text-align: center;
            background: url("../../static/images/enterpriseRecruitment/cz-default.png") no-repeat;
          }

          .active {
            color: #fff;
            background: url("../../static/images/enterpriseRecruitment/cz-active.png") no-repeat;
          }
        }

        .imgnode {
          margin-top: 50px;
          height: 665px;
          width: 100%;

        }
      }

      .welfare {
        border: 1px solid rgba(0, 0, 0, 0);
        padding: 50px 100px;
        height: 890px;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-sizing: border-box;
        background: url("../../static/images/enterpriseRecruitment/fl.png") no-repeat;
        .content {
          width: 100%;
          height: 640px;
          display: flex;
          flex-wrap: wrap;
          border: 1px solid rgba(0, 0, 0, 0);
          margin-top: 70px;
          .item {
            width: 33.2%;
            height: 290px;
            border: 1px solid #F1F1F1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            background-color: #fff;

            .item-img {
              width: 101px;
              height: 101px;
            }
            .item-img:hover {
              transform: scale(1.2);
            }

          }

          .item1 {
            border-top-left-radius: 5%;
            border-left: none;
            border-top: none;

            /*.item-img {*/
            /*  background: url("../../static/images/enterpriseRecruitment/5-1.png") no-repeat;*/
            /*}*/
          }

          .item2 {
            border-top: none;

            /*.item-img {*/
            /*  background: url("../../static/images/enterpriseRecruitment/5-2.png") no-repeat;*/
            /*}*/
          }

          .item3 {
            border-top-right-radius: 5%;
            border-right: none;
            border-top: none;

            /*.item-img {*/
            /*  background: url("../../static/images/enterpriseRecruitment/5-3.png") no-repeat;*/
            /*}*/
          }

          .item4 {
            border-bottom-left-radius: 5%;
            border-left: none;
            border-bottom: none;

            /*.item-img {*/
            /*  background: url("../../static/images/enterpriseRecruitment/5-4.png") no-repeat;*/
            /*}*/
          }

          .item5 {
            border-bottom: none;

            /*.item-img {*/
            /*  background: url("../../static/images/enterpriseRecruitment/5-5.png") no-repeat;*/
            /*}*/
          }

          .item6 {
            border-right: none;
            border-bottom: none;
            border-bottom-right-radius: 5%;

            /*.item-img {*/
            /*  background: url("../../static/images/enterpriseRecruitment/5-6.png") no-repeat;*/
            /*}*/
          }
        }
      }

      .postinfo {
        /*border: 1px solid rgba(0, 0, 0, 0);*/
        width: 100%;
        height: auto;
        padding: 50px 100px;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-sizing: border-box;

        .content {
          width: 100%;
          // padding: 0 100px;
          box-sizing: border-box;
          margin-top: 70px;
          display: flex;
          justify-content: space-between;

          .item {
            padding: 60px 50px;
            // height: 278px;
            // width: 554px;
            height:30vh;
            width:28vw;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            background: url("../../static/images/enterpriseRecruitment/zp.png") no-repeat;

            .top {
              display: flex;
              justify-content: space-between;
              .secondary-title{
                font-size:2.8vh ;
              }

              .salary {
                color: red !important;
              }
            }

            .center {
              display: flex;
              justify-content: space-between;
              // height: 41px;
              height:4vh;

              div {
                // line-height: 41px;
                line-height:4vh;
                background-color: #EBF1FE;
                color: #5084F7;
                padding: 0 10px;
                // font-size: 20px;
                font-size: 2vh;
              }
            }

            .bottom {
              font-size: 20px;
              font-size: 2vh;
              display: flex;
              justify-content: space-between;
              color: rgba(31, 31, 31, 0.8);
            }
          }
        }
      }
    }
  }

  /deep/ .el-carousel {
    width: 100%;
    height: 100%;

  }

  /deep/ .el-carousel__container {
    width: 100%;
    height: 100%;
  }

  .animation {
    animation: revealAnimation 2s forwards;
    transform: translateY(100%);
  }

  //从下到上逐渐显示
  @keyframes revealAnimation {
    0% {
      transform: translateY(100%);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/enterpriseRecruitment/enterpriseRecruitment.vue